/**
 * @generated SignedSource<<7053b7eb6b4b3f2af19b7e28dc524520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList$data = {
  readonly projectListViewTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly isProductLicensed: boolean;
      readonly key: string;
      readonly productKey: string;
      readonly templateType: string;
      readonly " $fragmentSpreads": FragmentRefs<"card_projectsDirectoryTemplatesSidebar_TemplateCard" | "preview_projectsDirectoryTemplatesSidebar_TemplatePreview">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly userPreferences: {
    readonly __id: string;
  } | null | undefined;
  readonly " $fragmentType": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList";
};
export type ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList$key = {
  readonly " $data"?: ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList",
  "selections": [
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "experimentKey",
          "value": "sidebarExperiment"
        }
      ],
      "concreteType": "JiraProjectListViewTemplateConnection",
      "kind": "LinkedField",
      "name": "projectListViewTemplates",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectListViewTemplateItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "key"
              },
              "action": "THROW",
              "path": "projectListViewTemplates.nodes.key"
            },
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "templateType"
              },
              "action": "THROW",
              "path": "projectListViewTemplates.nodes.templateType"
            },
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "productKey"
              },
              "action": "THROW",
              "path": "projectListViewTemplates.nodes.productKey"
            },
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "isProductLicensed"
              },
              "action": "THROW",
              "path": "projectListViewTemplates.nodes.isProductLicensed"
            },
            {
              "kind": "FragmentSpread",
              "name": "card_projectsDirectoryTemplatesSidebar_TemplateCard"
            },
            {
              "kind": "FragmentSpread",
              "name": "preview_projectsDirectoryTemplatesSidebar_TemplatePreview"
            }
          ]
        }
      ]
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "cb3cd1eb69b348c8ecc62b322098e37b";

export default node;
